export const formatRupiah = (n) => {
  const val = Number(n || 0);
  return "Rp " + val.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const formatTanggal = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTanggalPendek = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short" });
};
